export { default as SvgUniqueID } from './SvgUniqueID.mjs';
export { toSingleton } from './utils/index.mjs';
